<script setup lang="ts">
import { useMaterialComposable } from '@/components/materials/composable/useMaterialComposable'
import { HelpTextTooltip, TextField } from '@haskoning/vue-component-library'

const { materialStore, currentItem, hasHelpText } = useMaterialComposable()
const gabionFields = [
  'gabion_rock_density',
  'gabion_rock_porosity',
  'angle_repose_gabion',
  'gabion_angle_repose_rock'
]
</script>

<template>
  <v-card elevation="0" flat>
    <v-card-title class="header-font"> Gabion</v-card-title>
    <v-card-subtitle class="description-font">
      Define the material conditions that will applied to all calculations in your project.
    </v-card-subtitle>

    <v-card-text>
      <v-row align="center" no-gutters v-for="field in gabionFields" :key="field">
        <v-col cols="12" md="8" lg="4" class="d-flex align-center">
          <HelpTextTooltip
            v-if="hasHelpText(field)"
            :text="materialStore.fields[field].help_text || ''"
          />
          <span :class="hasHelpText(field) ? 'px-2' : 'px-0'">
            {{ materialStore.fields[field].label }}
          </span>
        </v-col>

        <v-col cols="12" md="8" lg="4" class="pt-0">
          <TextField
            :field="materialStore.fields[field]"
            :model-value="currentItem"
            :no-help-text="true"
            :readonly="!materialStore.canChangeMaterial"
            @update="materialStore.update(currentItem)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
